import { useEffect, useState } from 'react';

import getUploadMessage, {
  UPLOAD_MESSAGE_MARKS_MS,
} from '@/utils/upload/getUploadMessage';

import type { UploadMediaType } from '@/types/upload';

/**
 * What a surface should say about the upload in flight, escalating as the marks
 * in `UPLOAD_MESSAGE_MARKS_MS` elapse.
 *
 * Mount *is* the zero, so callers must mount their status UI only while a file
 * is actually in flight. Not driven off `isLoading`: on native that flag is
 * raised before the OS picker opens, which would bill gallery-browsing time as
 * upload time.
 */
const useUploadMessage = (mediaType: UploadMediaType): string => {
  const [marksPassed, setMarksPassed] = useState(0);

  useEffect(() => {
    const timers = UPLOAD_MESSAGE_MARKS_MS.map((mark, index) =>
      setTimeout(() => setMarksPassed(index + 1), mark)
    );

    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);

  return getUploadMessage({ marksPassed, mediaType });
};

export default useUploadMessage;
